<section *ngIf="loading">Loading Application
  <app-spin-icon></app-spin-icon>
</section>
<section *ngIf="!loading">
  <dac-assessment-single-question-display [assessment]="assessment" (onSubmit)="submit($event)" [disabled]="saving"></dac-assessment-single-question-display> 
</section>


// WEBPACK FOOTER //
// ./src/app/assessments/take-assessment/take-assessment.component.html